import { extendTheme } from '@chakra-ui/react'

export const mainTheme = extendTheme({
  fonts: {
    heading: 'Poppins',
    body: 'Poppins',
  },
})
